import { editorClient } from "@/lib/editorClient";
import { LanguageKey } from "@op/puck-types";
import { notFound } from "@tanstack/react-router";

export async function getPageDraftVersionId(
  organizationSlug: string,
  projectSlug: string,
  languageKey: LanguageKey,
  topicSlug: string,
  pageSlug: string
) {
  const res = await editorClient.pages[":organizationSlug"][":projectSlug"][
    ":languageKey"
  ][":topicSlug"][":pageSlug"].draft.$get({
    param: {
      organizationSlug,
      projectSlug,
      languageKey,
      topicSlug,
      pageSlug,
    },
  });
  if (!res.ok) {
    if (res.status === 404) throw notFound();
    throw new Error("Failed to get page draft version id");
  }
  const data = await res.json();
  return data;
}
